import { render, staticRenderFns } from "./OperationNoteModel.vue?vue&type=template&id=b2d88e78&scoped=true&"
import script from "./OperationNoteModel.vue?vue&type=script&lang=js&"
export * from "./OperationNoteModel.vue?vue&type=script&lang=js&"
import style0 from "./OperationNoteModel.vue?vue&type=style&index=0&id=b2d88e78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d88e78",
  null
  
)

export default component.exports